import { useEffect, useRef, useState } from 'react';
import Promise from 'bluebird';

export const useStateObject = (initialObject) => {
  const [ properties, setProperties ] = useState(initialObject);
  useEffect(() => {
    if (undefined === properties) {
      setProperties(initialObject);
    }
  }, [ initialObject, properties ]);
  const setProperty = (property, value) => {
    return setProperties((prev) => {
      return {
        ...prev,
        [property]: 'function' === typeof value ? value(prev[property], prev) : value,
      };
    });
  };
  return [ properties, setProperty ];
};

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export function sanitizeInOperator(array) {
  if (!Array.isArray(array) || 0 === array.length) {
    return [ -1 ];
  }

  return array;
}

export function fileToDataURL(file) {
  if (!file) {
    throw new Error('Provide a file');
  }
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target.result);
    };
    reader.readAsDataURL(file);
  });
}

export const limitConcurrency = async (queue, concurrency) => {
  let index = 0;
  const results = [];

  // Run a pseudo-thread
  const execThread = async () => {
    while (index < queue.length) {
      // eslint-disable-next-line no-plusplus
      const curIndex = index++;
      try {
        // Use of `curIndex` is important because `index` may change after await is resolved
        // eslint-disable-next-line no-await-in-loop
        results[curIndex] = await queue[curIndex];
        // console.log(results[curIndex]);
      } catch (err) {
        console.log('ERROR', err);
        results[curIndex] = err;
      }
    }
  };

  // Start threads
  const threads = [];
  for (let thread = 0; thread < concurrency; thread++) {
    threads.push(execThread());
  }
  await Promise.all(threads);
  return results;
};
